import React, { useRef } from 'react'
import * as ethicsFormType from './ethicsFormTypes'
import useLookupService from '../../../../services/lookup/useLookupService'
import { useForm } from 'react-final-form'
import useLookupClient from '../../../../services/lookupClient/useLookupClient'
import useTranslate from '../../../../i18n/useTranslate'
import useManageProjectStore from '../../../../stores/manageProject/useManageProjectStore'
import useIRB from '../../../../services/um/lookups/useIRB'
import useSnackbarAction from '../../../../stores/snackbar/snackbarAction'

const useEthicsForm = (props: ethicsFormType.UseEthicsFormType) => {
    const {
        callbackChangeFaculty,
        callbackChangeResearcherType,
        isEditAfterReview,
        isNeedEditForm: defaultIsNeedEditForm = false,
    } = props
    const form = useForm()
    const translate = useTranslate()
    const lookupClient = useLookupClient()
    const callLookup = useLookupService()
    const { irb } = useIRB()
    const [categoryProject, setCategoryProject] = React.useState<ethicsFormType.OptType[]>([])
    const [faculty, setFaculty] = React.useState<ethicsFormType.OptType[]>([])
    const [researcherType, setResearcherType] = React.useState<ethicsFormType.OptType[]>([])
    const [titleNameList, setTitleNameList] = React.useState<ethicsFormType.OptType[]>([])
    const [academicPositionList, setAcademicPositionList] = React.useState<ethicsFormType.OptType[]>([])
    const [educationList, setEducationList] = React.useState<Array<ethicsFormType.OptType>>([])
    const [researcherTypeSelected, setResearcherTypeSelected] = React.useState<string>()
    const [textRemaining, setTextRemaining] = React.useState<{ TH: number; EN: number }>({ TH: 500, EN: 500 })

    const [isPhase, setIsPhase] = React.useState<boolean>(false)
    const [isNeedEditForm, setIsNeedEditForm] = React.useState<boolean>(true)
    const manageProjectStore = useManageProjectStore()

    const [isShowAcademicPosition, setIsShowAcademicPosition] = React.useState<boolean>(false)

    const lookupFacultyResponse = useRef<Array<Partial<{ id: number; name_th: string; name_en: string; irb: number }>>>(
        [],
    )

    const snackbarAction = useSnackbarAction()

    React.useEffect(() => {
        getCategoryProject()
        getFaculty()
        getEducationLevel()
        getResearcherType()
        getTitleName()
        getAcademicPosition()
        getEducationLevel()
    }, [translate.languageStore.currentLanguage])

    React.useEffect(() => {
        if (isEditAfterReview || manageProjectStore?.projectData?.isFlowApproveWithComment) {
            if (
                manageProjectStore.projectData?.previousIsNeedEditForm !== null &&
                manageProjectStore.projectData?.previousIsNeedEditForm !== undefined
            ) {
                setIsNeedEditForm(manageProjectStore.projectData?.previousIsNeedEditForm)
            }
        }
    }, [manageProjectStore.projectData?.submittedID ?? null])

    React.useEffect(() => {
        const formVal = form.getState().values
        const textRemainingTH = formVal?.projectNameTH?.length ? 500 - formVal?.projectNameTH?.length : 500
        const textRemainingEN = formVal?.projectNameEN?.length ? 500 - formVal?.projectNameEN?.length : 500
        setTextRemaining({ TH: textRemainingTH, EN: textRemainingEN })

        if (form.getState().values?.isNeedEditForm === '1') {
            setIsNeedEditForm(defaultIsNeedEditForm)
        }
    }, [form.getState().values.projectNameTH ?? null, form.getState().values.projectNameEN ?? null])

    React.useEffect(() => {
        const formVal = form.getState().values
        if (formVal?.researcherType?.value === '1') {
            setIsShowAcademicPosition(false)
        } else {
            setIsShowAcademicPosition(true)
        }
    }, [form.getState().values])

    const getEducationLevel = async () => {
        const res = await callLookup.getEducationLevel()
        const formatData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })
        setEducationList(formatData)
    }

    const getCategoryProject = async () => {
        const res = await callLookup.callProjectSubmitTypeLut()
        lookupFacultyResponse.current = res.result
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })
        setCategoryProject(formatedData)
    }

    const getFaculty = async () => {
        const res = await callLookup.callFacultyLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
                irb: `${itm.irb}`,
            }
        })

        setFaculty(formatedData)
    }

    const getResearcherType = async () => {
        const res = await callLookup.callResearcherTypeLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })

        setResearcherType(formatedData)
    }

    const getTitleName = async () => {
        const res = await callLookup.callTitleNameLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })

        setTitleNameList(formatedData)
    }

    const getAcademicPosition = async () => {
        const res = await callLookup.callAcademicPositionLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })

        const academicPosition = [...formatedData]

        setAcademicPositionList(academicPosition)
    }

    const handleChangeResearcherType = (val: { value: string; label: string }) => {
        if (val && callbackChangeResearcherType) {
            callbackChangeResearcherType(val.value)
            setResearcherTypeSelected(val?.value)

            const isCant = val?.value === ethicsFormType.ResearcherType.student
            if (!isCant) {
                setIsShowAcademicPosition(true)
            } else {
                setIsShowAcademicPosition(false)
            }
        }
    }
    const handleChangeAcademicPosition = (val: string) => {
        if (val !== '6') {
            form.change('otherAcademicPositionTH', null)
            form.change('otherAcademicPositionEN', null)
            form.restart()
        }
    }

    const handleChangeTitleName = (val: string) => {
        if (val !== '5') {
            form.change('otherTitleNameTH', null)
            form.change('otherTitleNameEN', null)
            form.restart()
        }
    }
    const handleChangeFaculty = (val: { value: string; label: string; irb?: string }) => {
        const selectedIrb = irb.filter((itm) => itm.value === val?.irb)
        form.change('IRB', selectedIrb.length > 0 ? selectedIrb[0] : null)
        if (callbackChangeFaculty) {
            callbackChangeFaculty(val?.irb)
        }
    }
    const handleChangeIsPhase = (val: string) => {
        const isPhase = val === '2' ? true : false
        setIsPhase(isPhase)
    }
    const handleChangeIrb = (val: { value: string; label: string }) => {
        if (callbackChangeFaculty) {
            callbackChangeFaculty(val?.value)
        }
    }
    const handleChangeHomePhone = (val: string) => {
        if (val) {
            form.change('homePhone', val.replace(/[^\d]/g, '').slice(0, 20))
        }
    }
    const handleChangeMobilePhone = (val: string) => {
        if (val) {
            form.change('mobilePhone', val.replace(/[^\d]/g, '').slice(0, 20))
        }
    }

    const handleChangeNeedEditForm = (val: string) => {
        const isNeedEditForm = val === '2' ? true : false
        setIsNeedEditForm(isNeedEditForm)
        if (isNeedEditForm) {
            snackbarAction.openSnackbar({
                message: translate.get('ALERT.CONTENT.CHECK_YOUR_INFORMATION'),
                type: 'warning',
            })
        }
    }

    const handleChangeCertificatePaper = () => {}

    const handleChangTextField = (val: string, language: string) => {
        let objText = textRemaining
        if (language === 'TH') {
            objText = { TH: 500 - val.length, EN: textRemaining.EN }
        } else {
            objText = { TH: textRemaining.TH, EN: 500 - val.length }
            setTextRemaining({ TH: 500 - val.length, EN: textRemaining.EN })
        }
    }

    const addResearcher = (index?: number) => {
        const mutators = form.mutators
        const payload = {}
        if (typeof index === 'number' && mutators.insert) {
            mutators.insert('researchers', index, payload)
        } else {
            mutators.push('researchers', payload)
        }
    }

    return {
        faculty,
        researcherType,
        categoryProject,
        titleNameList,

        academicPositionList,
        researcherTypeSelected,
        isPhase,
        educationLevelLut: educationList,
        textRemaining,
        isCertificatePaperList: lookupClient.getRequest(),
        isNeedEditForm,
        irbLut: irb,
        isPhaseLut: lookupClient.getYesNo(),
        isToolsLut: lookupClient.getYesNo(),
        isShowAcademicPosition,
        onChangeResearcherType: handleChangeResearcherType,
        onChangeAcademicPosition: handleChangeAcademicPosition,
        onChangeTitleName: handleChangeTitleName,
        onChangeFaculty: handleChangeFaculty,
        onChangeIsPhase: handleChangeIsPhase,
        onChangeIrb: handleChangeIrb,
        onChangeHomePhone: handleChangeHomePhone,
        onChangeMobilePhone: handleChangeMobilePhone,
        onChangeCertificatePaper: handleChangeCertificatePaper,
        onChangTextField: handleChangTextField,
        onChangeNeedEditForm: handleChangeNeedEditForm,
        addResearcher,
    }
}

export default useEthicsForm
